module.exports = __webpack_public_path__ + "static/hero-2257628e075c0dc61210e0100a4c997f.png";